import Vue from 'vue'
import axios from 'axios'
import config from "./config";
const baseURL = config.baseUrl;

/**
 * 下载文件 用于excel导出
 * @param url
 * @param parameter
 * @returns {*}
 */
function downFile(url, parameter) {
  return axios({
    url: baseURL+url,
    params: parameter,
    method: 'get',
    responseType: 'blob',
    headers: {
      'content-type': 'application/json',
      "X-Access-Token":localStorage.getItem('token')  //token换成从缓存获取
    }
  })
}

/**
 * 下载文件
 * @param url 文件路径
 * @param fileName 文件名
 * @param parameter
 * @returns {*}
 */
function downloadFile(url, fileName, parameter) {
  console.log(url,"url")
  return downFile(url, parameter).then((res) => {
    if (!res.data || res.data.size === 0) {
      Vue.prototype['$message'].warning('文件下载失败')
      return
    }
    if(typeof(res.headers.filetype) != 'undefined'){
      let filetype = res.headers.filetype
      let fileNameArr = fileName.split(".");
      fileName = fileName.replace(fileNameArr[fileNameArr.length-1],filetype)
    }
    if (typeof window.navigator.msSaveBlob !== 'undefined') {
      window.navigator.msSaveBlob(new Blob([res.data]), fileName)
    } else {
      let url = window.URL.createObjectURL(new Blob([res.data]))
      console.log(url,"url")
      let link = document.createElement('a')
      link.style.display = 'none'
      link.href = url
      link.setAttribute('download', fileName)
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link) //下载完成移除元素
      window.URL.revokeObjectURL(url) //释放掉blob对象
    }
  })
}
function uploadAction(url, parameter) {
  return axios({
    url: baseURL+url,
    data: parameter,
    method: 'post',
    headers: {
      'Content-Type': 'multipart/form-data',  // 文件上传
      "X-Access-Token":localStorage.getItem('token')
    }
  })
}

export default {
  downloadFile,
  uploadAction
}



// WEBPACK FOOTER //
// ./src/api/manage.js